import src from "IMAGE";
export default { src, width: 31, height: 31, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
